module.exports = {"mainText":"Trello is now available in English!","switchText":"Try it out!","dismissText":"No thanks"}